// Act 2 orchestrator — cutscene → intake → outro.
// Returns the player state when the act completes.

import { runCutscene } from "./cutscene";
import { runIntake, type PlayerState } from "./intake";

export type { PlayerState };

import _welcomeImg  from "../assets/o-also-title.png";
import _finalScene  from "../assets/o-also-scene.png";

const WELCOME_IMG     = _welcomeImg;
const FINAL_SCENE_IMG = _finalScene;

export function startAct2(root: HTMLElement): Promise<PlayerState> {
  root.id = "act2-root";
  return runCutscene(root)
    .then(() => {
      root.innerHTML = "";
      return runIntake(root);
    })
    .then(async (state) => {
      root.innerHTML = "";
      await runOutro(root);
      return state;
    });
}

async function runOutro(root: HTMLElement): Promise<void> {
  root.className = "act2-outro";

  const frame = el("div", "outro-frame");
  root.append(frame);

  // WELCOME TO O:ALSO graphic
  if (WELCOME_IMG) frame.style.backgroundImage = `url("${WELCOME_IMG}")`;
  frame.dataset.label = "welcome";
  await wait(80);
  frame.classList.add("outro-in");
  await wait(2800);
  frame.classList.remove("outro-in");
  await wait(1000);

  // Final scene — looking through the window
  frame.style.backgroundImage = FINAL_SCENE_IMG ? `url("${FINAL_SCENE_IMG}")` : "";
  frame.dataset.label = "final";
  frame.classList.add("outro-in");
  await wait(3200);
  frame.classList.remove("outro-in");
  await wait(1000);

  // Act 3 title card
  frame.remove();
  const titleCard = el("div", "act3-title-card");
  titleCard.innerHTML = `
    <p class="act3-eyebrow">— ACT 3 —</p>
    <h1 class="act3-title">Where's My Home?</h1>
    <p class="act3-coming-soon">Coming Soon</p>
  `;
  root.append(titleCard);
  await wait(80);
  titleCard.classList.add("act3-in");
}


function wait(ms: number): Promise<void> {
  return new Promise((r) => setTimeout(r, ms));
}

function el(tag: string, className: string): HTMLElement {
  const e = document.createElement(tag);
  e.className = className;
  return e;
}
